/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientFeatureSwitchViewModel } from '../../models/client-feature-switch-view-model';

export interface SaveClientFeatureSwitches$Params {
  clientID: number;
      body?: Array<ClientFeatureSwitchViewModel>
}

export function SaveClientFeatureSwitches(http: HttpClient, rootUrl: string, params: SaveClientFeatureSwitches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientFeatureSwitchViewModel>>> {
  const rb = new RequestBuilder(rootUrl, SaveClientFeatureSwitches.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientFeatureSwitchViewModel>>;
    })
  );
}

SaveClientFeatureSwitches.PATH = '/api/Clients/SaveClientFeatureSwitches/{clientID}';
